export default "__VITE_ASSET__6564861b__"